import moment from 'moment-timezone';
import React, { useEffect, useState, useRef, useContext } from 'react'
import { Col, Container, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap'
import { useImmer } from 'use-immer';
//import { Scheduler } from "@aldabil/react-scheduler";
import '../css/customers.css'
import GlobalContext from '../GlobalContext';
import { useNavigate } from 'react-router-dom';
import { RiDeleteBin6Line, RiEditBoxLine, RiCheckLine, RiCloseLine, RiEraserLine, RiMenuAddLine, RiMessage2Line } from 'react-icons/ri'
import { MdOutlineMailOutline, MdPersonSearch, MdSearchOff } from 'react-icons/md'
import GoodSwitch from '../components/GoodSwitch';
import Sidebar from './Sidebar';
import Leftbar from './Leftbar';
import TextContext from '../TextContext';
import { RxUpdate } from 'react-icons/rx';
import ServiceContext from '../ServiceContext';
import CalendarContext from '../CalendarContext';

const checkNumber = (number) => {
    const continuos = number.split(" ").join("")
    // console.log("HEY",continuos)
    return (isInteger(continuos) && continuos.length > 6 && continuos.length < 15)
}
const compareApt = (a, b) => {
    // if (a.Events.length == 0 || b.Events.length == 0) {
    //     return 0;
    // }
    if (a.eve_start > b.eve_start) {
        return -1;
    }
    if (a.eve_start < b.eve_start) {
        return 1;
    }
    return 0;
}
const getColor = (bgColor) => {
    const rgb = hexToRgb(bgColor)
    if (rgb) {
        const total = rgb.r + rgb.g + rgb.b
        return (total / 3) >= 128 ? '#000000' : '#ffffff'
    } else {
        return '#FFF'
    }
}
const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    if (!hex) {
        return null
    }
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
const isInteger = (number) => {
    if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
    return !(number - parseInt(number));
}
const sortList = (list, compareFunc) => {
    let arr=JSON.parse(JSON.stringify(list))
     for(let i = 0; i < arr.length; i++){

        //Inner pass
        for(let j = 0; j < arr.length - i - 1; j++){

            //Value comparison using ascending order

            if(compareFunc(arr[j + 1],arr[j])==-1){

                //Swapping
                [arr[j + 1],arr[j]] = [arr[j],arr[j + 1]]
            }
        }
    };
    return arr;
}

const defaAddFormValues = {
    cus_name: "",
    cus_surname: "",
    cus_email: "",
    cus_enable_sms: false,
    cus_enable_wa: true,
    cus_enable_email: false,
    cus_birthday: null,
    phn_prefix: "+41",
    phn_number: "",
    cus_notes: ''
}
const defaultCheckValues={
    touched: {
        phn_ID: false,
        ID: false,
        cus_name: false,
        cus_surname: false,
        cus_email: false,
        cus_enable_sms: false,
        cus_enable_wa: false,
        cus_enable_email: false,
        cus_birthday: false,
        phn_prefix: false,
        phn_number: false,
        cus_notes: false
    },
    check: {
        phn_ID: (v) => { return true },
        ID: (v) => { return true },
        cus_name: (v) => { return v && v.length > 0 && v.length < 50 },
        cus_surname: (v) => { return v && v.length < 50 },
        cus_email: (v) => { return (v && v.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) || v=='' || v==undefined },
        cus_enable_sms: (v) => { return true },
        cus_enable_wa: (v) => { return true },
        cus_enable_email: (v) => { return true },
        phn_prefix: (v) => { return v && v.match(/\+[0-9]{1,3}$/) },
        cus_birthday: (v) => { return true },
        phn_number: (v) => { return v && checkNumber(v) },
    },
    good: {
        phn_ID: false,
        ID: false,
        cus_name: false,
        cus_surname: false,
        cus_email: false,
        cus_enable_sms: false,
        cus_enable_wa: false,
        cus_enable_email: false,
        phn_prefix: false,
        phn_number: false,
        cus_birthday: false,
        cus_notes: false
    },
    bad: {
        phn_ID: false,
        ID: false,
        cus_name: false,
        cus_surname: false,
        cus_email: false,
        cus_enable_sms: false,
        cus_enable_wa: false,
        cus_enable_email: false,
        phn_prefix: false,
        cus_birthday: false,
        phn_number: false,
        cus_notes: false
    },
}

const Customers = () => {

    const globalContext = useContext(GlobalContext)
    const textContext = useContext(TextContext)
    const serviceContext= useContext(ServiceContext)
    const calendarContext= useContext(CalendarContext)
    const navigate = useNavigate()
    const [showDetails, setShowDetails] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [showAdd, setShowAdd] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [showSameMail, setShowSameMail] = useState(false)
    const [resetSwitches, setResetSwitches] = useState(false)
    const [addForm, setAddForm] = useImmer(defaAddFormValues)
    const [editForm, setEditForm] = useImmer(defaAddFormValues)
    const [showSearch, setShowSearc] = useState(false)
    const [searchField, setSearchField] = useState('')
    const [showApt, setShowApt] = useState(false)
    const [appointments, setAppointments]= useImmer({})
    const [formChecks, setFormChecks] = useImmer(defaultCheckValues)
    const detailsRef = useRef()

    const filterList = (list) => {
        if (searchField == '') {
            return list
        }
        let newList = []
        list.forEach(cus => {
            const str = `${cus.cus_name.toLowerCase()} ${cus.cus_surname ? cus.cus_surname.toLowerCase() : ''}`
            if (str.includes(searchField.toLocaleLowerCase())) {
                newList.push(cus)
            }
        })
        return newList

    }
    const compareCus = (a, b) => {

        let alphabet = a.cus_name.localeCompare(b.cus_name)
        let shop = 0
        if (globalContext.get.Shop.ID == a.Shop_ID) {
            if (globalContext.get.Shop.ID != b.Shop_ID) {
                shop = -1
            }
        } else {
            if (globalContext.get.Shop.ID == b.Shop_ID) {
                shop = 1
            }
        }

        if (shop == -1 || alphabet == -1) {
            // console.log('-1')
            return -1;
        } else if (shop == 1 || alphabet == 1) {
            // console.log('1')
            return 1
        } else {
            // console.log('0')
            return 0;
        }
    }
    const capitalize = (s) => {
        return s && s[0].toUpperCase() + s.slice(1);
    }
    const checkForm = (values, check, setCheck, show = false) => {
        let pass = true
        Object.keys(values).forEach(k => {
            if (check.check.hasOwnProperty(k)) {
                if (k == 'cus_enable_sms') {
                    if (values[k]) {
                        if (!(check.check.phn_number(values.phn_number) && check.check.phn_prefix(values.phn_prefix))) {
                            setEditForm(draft => { draft.cus_enable_sms = false })
                            setAddForm(draft => { draft.cus_enable_sms = false })
                        }
                    }
                }
                if (k == 'cus_enable_email') {
                    if (values[k]) {
                        if (!check.check.cus_email(values.cus_email)) {
                            setEditForm(draft => { draft.cus_enable_email = false })
                            setAddForm(draft => { draft.cus_enable_email = false })
                        }
                    }
                }
                if (check.check[k](values[k])) {
                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.good[k] = true })
                        setCheck(draft => { draft.bad[k] = false })
                    }
                } else {
                    pass = false
                    // console.log('check fallito', k, check.check)
                    if (show || check.touched[k]) {
                        setCheck(draft => { draft.bad[k] = true })
                        setCheck(draft => { draft.good[k] = false })
                    }
                }
            }

        })
        return pass
    }
    const checkAddMail= ()=>{
        const mail=addForm.cus_email;
        if(mail.length>0){
            const same=globalContext.get.customers.filter(cus=>cus.cus_email==mail)
            console.log('customers: ', same)
            if(same.length>0){
                setShowSameMail(true)
            } else {
                setShowSameMail(false)
            }
        } else {
            setShowSameMail(false)
        }
    }
    const sortCustomers=async()=>{
        const old=JSON.parse(JSON.stringify(globalContext.get.customers))
        console.log('old', old, )
        const newCustomers= sortList(old, compareCus)
        console.log('new', newCustomers)
        globalContext.set(draft => { draft.customers = newCustomers })
    }
    const loadAppointments= async (ID, start=moment.utc().subtract(1, 'year').unix(), end=moment.utc().add(1, 'month').unix()) =>{
        // console.log('loadAppointments', appointments)
        if(!appointments.hasOwnProperty(ID)){
        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/events?start=${start}&end=${end}&cID=${ID}`, {
            method: 'GET',
            credentials: 'include'
        })
        if(resp.status==200){
            const respValue=await resp.json()
            const processedEvents=respValue.data.map(event=>{

                let title=event.eve_title
                let cat=event.Category
                if(!cat){
                    cat={cat_name: 'nocategory'}
                }
                if(event.eve_autogen_title){
                    if(event.Appointment_ID&&event.Appointment&&event.Appointment.Customer) {
                        const customer=event.Appointment.Customer
                        title=`${cat.cat_name} ${customer.cus_name} ${customer.cus_surname}`
                    } else {
                        title=`${cat.cat_name}`
                    }
                }
                event.eve_title=title
                return event

            })
            setAppointments(draft=>{draft[ID]=processedEvents})
        }

        }
    }
    const loadCustomers = async (ID = false, edit=false) => {
        // console.log('load customers called', ID, edit)
        let resp 
        if(ID){
            resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers?ID=${ID}`, {
                method: 'GET',
                credentials: 'include'
            })
        } else {
            resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
                method: 'GET',
                credentials: 'include'
            })
        }
        const respValue = await resp.json()

        //console.log(sortList(respValue.data,compareCus))

        if (resp.status == 200) {
            if(ID&&edit){
                const newCustomers=[...globalContext.get.customers.filter(cus=>cus.ID!==respValue.data[0].ID), ...respValue.data]
                globalContext.set(draft => { draft.customers = newCustomers })
                setShowAdd(false)
                setShowEdit(false)
                setShowDetails(respValue.data[0])
            } else if (ID) {
                const newCustomers=[...globalContext.get.customers, ...respValue.data]
                globalContext.set(draft => { draft.customers = newCustomers })
                setShowAdd(false)
                setShowEdit(false)
                setShowDetails(respValue.data[0])
            } else {
                globalContext.set(draft => { draft.customers = respValue.data })
            }
        }
    }
    const loadParams = async () => {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        if (searchParams.get('cID') !== null) {
            const customer = globalContext.get.customers.filter(cus => cus.ID == searchParams.get('cID'))
            if (customer.length > 0) {
                setShowDetails(customer[0])
            }
        }
    }
    const addCustomer = async () => {
        if (!checkForm(addForm, formChecks, setFormChecks, true)) {
            console.log('failed check', formChecks)
            return
        }
        globalContext.set(draft=>{draft.PreventReloads.customers=true})
        setShowAdd(false)
        let notes = ''
        if (addForm.cus_notes) {
            notes = String(addForm.cus_notes).substring(0, 149)
        }
        const cusBody = {
            cus_name: capitalize(addForm.cus_name),
            cus_surname: capitalize(addForm.cus_surname),
            cus_email: addForm.cus_email,
            cus_notes: notes,
            cus_enable_sms: addForm.cus_enable_sms,
            cus_enable_wa: addForm.cus_enable_wa,
            cus_enable_email: addForm.cus_enable_email,
            cus_birthday: addForm.cus_birthday,
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(cusBody)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            const phnBody = {
                phn_prefix: addForm.phn_prefix,
                phn_number: addForm.phn_number,
                Customer_ID: respValue.data.ID
            }

            const respi = await fetch(`${globalContext.get.backendUrl}/papiv1/PhoneNumbers`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(phnBody)
            })
                resetAdd()
                // loadCustomers(respValue.data.ID)
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['add_client'], textContext.value),
                ttl: 2000
            })})
        } else {
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message:textContext.get(['calendar', 'notify'], ['error_client'], textContext.value),
                ttl: 2000
            })})
        }
    }
    const editCustomer = async () => {

        if (!checkForm(editForm, formChecks, setFormChecks, true)) {
            console.log('failed check', formChecks)
            return
        }
        globalContext.set(draft=>{draft.PreventReloads.customers=true})
        let notes = ''
        if (editForm.cus_notes) {
            notes = String(editForm.cus_notes).substring(0, 149)
        }
        const cusBody = {
            ID: editForm.ID,
            cus_name: capitalize(editForm.cus_name),
            cus_surname: capitalize(editForm.cus_surname),
            cus_email: editForm.cus_email,
            cus_notes: notes,
            cus_enable_sms: editForm.cus_enable_sms,
            cus_enable_wa: editForm.cus_enable_wa,
            cus_enable_email: editForm.cus_enable_email,
            cus_birthday: editForm.cus_birthday,
        }

        const resp = fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(cusBody)
        })
        const phnBody = {
            ID: editForm.phn_ID,
            phn_prefix: editForm.phn_prefix,
            phn_number: editForm.phn_number,
            Customer_ID: editForm.ID
        }

        const respi = fetch(`${globalContext.get.backendUrl}/papiv1/PhoneNumbers`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(phnBody)
        })

        const cusResp=await resp
        const phnResp=await respi

        if(cusResp.status==200&&phnResp.status==200){
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message:textContext.get(['calendar', 'notify'], ['modify_client'], textContext.value),
                ttl: 2000
            })})
            const respValue=await cusResp.json()
            globalContext.set(draft=>{draft.Reloads.customers=respValue.data})
            setShowDetails(respValue.data)
        } else {
            setShowDetails(detailsRef.current)
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['error_modify'], textContext.value),
                ttl: 2000
            })})
        }

        closeEdit()
        // loadCustomers(editForm.ID,true)
    }
    const deleteCustomer = async (ID) => {
        setShowDelete(false)
        const Body = {
            ID: ID
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/customers`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(Body)
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            // loadCustomers()
            setShowDetails(false)
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['delete_client'], textContext.value),
                ttl: 2000
            })})
        } else {
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['delete_error'], textContext.value),
                ttl: 2000
            })})
        }
    }
    const loadEdit = (customer) => {
        setEditForm({
            ID: customer.ID,
            cus_name: customer.cus_name,
            cus_surname: customer.cus_surname,
            cus_email: customer.cus_email,
            cus_notes: customer.cus_notes,
            cus_enable_sms: customer.cus_enable_sms,
            cus_enable_wa: customer.cus_enable_wa,
            cus_enable_email: customer.cus_enable_email,
            cus_birthday: customer.cus_birthday,
            phn_prefix: customer.PhoneNumbers.length && `+${customer.PhoneNumbers[0].phn_prefix}`,
            phn_number: customer.PhoneNumbers.length && customer.PhoneNumbers[0].phn_number,
            phn_ID: customer.PhoneNumbers.length && customer.PhoneNumbers[0].ID
        })
        detailsRef.current = showDetails
        setShowDetails(false)
        setShowEdit(true)
        setResetSwitches(true)
    }
    const closeEdit = () => {
        // setShowDetails(detailsRef.current)
        setShowEdit(false)
        setEditForm(defaAddFormValues)
        setFormChecks(defaultCheckValues)
    }
    const resetAdd = () => {
        setAddForm(defaAddFormValues)
        setResetSwitches(true)
        setFormChecks(defaultCheckValues)
    }
    const isLogged = async () => {
        const resp = await fetch(`${globalContext.get.backendUrl}/login`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            return true
        } else {
            return false
        }
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }

    useEffect(() => {

        // globalContext.set(draft => { draft.Reloads.events = true })
        loadParams()
        // loadAppointments(10)
        const check = async () => {
            if (!await isLogged()) {
                navigate('/')
            }
        }
        check()
        //sortCustomers()
        const checkLog = setInterval(async () => {
            if (!await isLogged()) {
                navigate('/')
            }
        }, 30000);
        return () => {
            clearInterval(checkLog);
        }
    }, [])
    useEffect(() => {
        if (resetSwitches) {
            setResetSwitches(false)
        }
    }, [resetSwitches])
    useEffect(() => {
        checkForm(addForm, formChecks, setFormChecks)
        checkAddMail()
    }, [addForm])
    useEffect(() => {
        checkForm(editForm, formChecks, setFormChecks)
    }, [editForm])
    useEffect(()=>{
        if(showDetails){
            loadAppointments(showDetails.ID)
        }
    },[showDetails])
    useEffect(()=>{
        // console.log(globalContext.get.selectedShop)
        setAddForm(draft=>{draft.phn_prefix=`+${globalContext.get.selectedShop.sho_default_prefix}`})
    },[showAdd])
    

    return (
        <>
            <Container fluid style={{ backgroundColor: globalContext.get.Theme.palette[1], height: '99.5%', margin: 0, color: globalContext.get.Theme.palette[3] }}>
                <Row className='' >
                    <Sidebar />
                    <Col xs={2} className='customers-list-container'>
                        <Row className='customers-list-header'>
                            {showSearch ? (
                                <>
                                    <Col xs={3} className='d-flex justify-content-center'>
                                        <MdSearchOff style={{ cursor: 'pointer' }} onClick={() => { setShowSearc(false); setSearchField('') }} />
                                    </Col>
                                    <Col xs={9}>
                                        <InputGroup>
                                            <FormControl
                                                type='text'
                                                value={searchField}
                                                onChange={(e) => setSearchField(e.target.value)}
                                                className='customers-search-field'
                                            />
                                        </InputGroup>
                                    </Col>
                                </>
                            ) : (
                                <>
                                    <Col xs={3} className='d-flex justify-content-center'>
                                        <MdPersonSearch style={{ cursor: 'pointer' }} onClick={() => setShowSearc(true)} />
                                    </Col>
                                    <Col xs={6} className='d-flex justify-content-center nac-title' >
                                        {textContext.get(['customers', 'form_customers'], ['customer_list'], textContext.value)}
                                    </Col>
                                    {getPermission('gro_aer_customer', 0) ? (
                                        <Col xs={3} className='d-flex justify-content-center customers-list-addbutton' onClick={() => { setShowAdd(true); setShowDetails(false); setShowEdit(false) }} >
                                            +
                                        </Col>
                                    ) : (<></>)}
                                </>
                            )}
                        </Row>
                        <Row className='customers-list-body' >
                            {filterList(sortList(globalContext.get.customers, compareCus)).map(cus => (
                                <span key={cus.ID}>
                                    <Row  className={`d-flex justify-content-center customers-list-item `} onClick={() => { setShowDetails(cus); setShowAdd(false); setShowEdit(false) }} >
                                        <p className={`customer-element-container d-flex justify-content-center mx-2 ${showDetails.ID == cus.ID && 'customer-element-container-selected'}`}>
                                            {cus.cus_name} {cus.cus_surname}
                                        </p>
                                    </Row>
                                    <hr className='list-hr' />
                                </span>
                            ))}
                        </Row>

                    </Col>
                    {showDetails && (
                        <Col xs={7} className='customers-detail-container'>
                            <Row style={{ height: "100%" }}>
                                <Col xs={6}>
                                    <Row className='customer-detail-anagraph'>
                                        <Row className='my-4 nac-title' style={{ fontSize: `${parseInt(globalContext.get.Theme.text_size) + 15}pt` }}>
                                            {showDetails.cus_name && capitalize(showDetails.cus_name)} {showDetails.cus_surname && capitalize(showDetails.cus_surname)}
                                        </Row>
                                        <Row className='mt-1 nac-text' style={{ fontSize: `${parseInt(globalContext.get.Theme.text_size) + 5}pt` }}>
                                            {showDetails.PhoneNumbers[0] ? (
                                                <span
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => window.open(`tel:${showDetails.PhoneNumbers[0].phn_prefix}${showDetails.PhoneNumbers[0].phn_number}`)}
                                                >
                                                    +{showDetails.PhoneNumbers[0] && showDetails.PhoneNumbers[0].phn_prefix} {showDetails.PhoneNumbers[0] && showDetails.PhoneNumbers[0].phn_number}
                                                </span>
                                            ) : (
                                                <span style={showDetails.cus_enable_sms?{color: '#FF0000'}:{}}>
                                                    {textContext.get(['customers', 'info_customers'], ['no_phone'], textContext.value)}
                                                </span>
                                            )}
                                        </Row>
                                        <Row className='nac-text' style={{ fontSize: `${parseInt(globalContext.get.Theme.text_size) + 5}pt` }}>
                                            {showDetails.cus_email ?
                                                <span
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => window.open(`mailto:${showDetails.cus_email}`)}
                                                >
                                                    {showDetails.cus_email}
                                                </span>
                                                : (
                                                    <span style={showDetails.cus_enable_email?{color: '#FF0000'}:{}} >
                                                        {textContext.get(['customers', 'info_customers'], ['no_mail'], textContext.value)}
                                                    </span>
                                                )}
                                        </Row>
                                        {showDetails.cus_birthday&&
                                            <Row className='nac-text' style={{ fontSize: `${parseInt(globalContext.get.Theme.text_size) + 5}pt` }}>
                                               <span>{textContext.get(['customers', 'info_customers'], ['festa'], textContext.value)} {moment(showDetails.cus_birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')}</span>
                                            </Row>
                                        }
                                        <Row className='nac-text'>
                                            <span>
                                            {textContext.get(['customers', 'info_customers'], ['shop'], textContext.value)} {globalContext.get.shops.filter(sho => sho.ID == showDetails.Shop_ID)[0].sho_name}
                                            </span>
                                        </Row>
                                        <Row className='nac-text'>
                                            <span>
                                            {showDetails.cus_notes && `Note: ${showDetails.cus_notes}`}
                                            </span>
                                        </Row>
                                        <Row className='mt-3 nac-text'>
                                            <Col className='d-flex justify-content-center' xs={3}>
                                                <RiMessage2Line className={`${!showDetails.cus_enable_sms ?"nac-disabled":"active"}`} size={`34pt`} />
                                            </Col>

                                            <Col xs={3}>
                                                <MdOutlineMailOutline className={`${!showDetails.cus_enable_email ?"nac-disabled":"active"}`} size={`34pt`} />
                                            </Col>
                                        </Row>

                                    </Row>
                                    <Row className='customer-detail-buttons'>
                                        <Col xs={3}>
                                            {getPermission('gro_aer_customer', 2) ? (
                                                <button type="button" className='nac-button'>
                                                    <RiDeleteBin6Line className='customer-detail-button' onClick={() => setShowDelete(true)} size={'4vh'} />
                                                </button>
                                            ) : (<></>)}
                                        </Col>
                                        <Col xs={3}>
                                            {getPermission('gro_aer_customer', 1) ? (
                                                <button type="button" className='nac-button'>
                                                    <RiEditBoxLine className='customer-detail-button' onClick={() => { loadEdit(showDetails) }} size={'4vh'} />
                                                </button>
                                            ) : (<></>)}

                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={6} className='mt-4'>
                                    <Row className='customer-detail-apt-header d-flex justify-content-center mt-4' >
                                        {textContext.get(['customers', 'form_customers'], ['customer_appointment'], textContext.value)}
                                    </Row>
                                    <Row className=' d-flex justify-content-center'>
                                        <Col className='mx-4 customer-detail-apt-list'>
                                            {appointments.hasOwnProperty(showDetails.ID)?(
                                            JSON.parse(JSON.stringify(appointments[showDetails.ID])).sort(compareApt).map(eve => 
                                                (
                                                <Row className='my-2 mx-2 customer-detail-apt-item' onClick={() => setShowApt(eve)} key={eve.ID + 1} style={{ backgroundColor: eve.Category ? eve.Category.cat_color : '#FF00FF' }}>
                                                    <p className='nac-title' style={{ color: getColor( eve.Category ? eve.Category.cat_color : '#FF00FF') }} key={eve.ID + 2} >{eve.eve_title}</p>
                                                    <p className='nac-text d-flex' style={{ color: getColor( eve.Category ? eve.Category.cat_color : '#FF00FF') }} key={eve.ID + 3} >{moment(eve.eve_start, 'X').format("DD/MM/YYYY HH:mm")}
                                                    {eve.rec_index!==undefined ? (
                                                        <RxUpdate className='cus-apt-recursive-icon' size={18} />
                                                    ) : (<></>)}
                                                    </p>
                                                </Row>
                                                )
                                            )):(<></>)}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    )}
                    {showAdd && (
                        <Col xs={7} className='customers-add-container'>
                            <Form>
                                <Row style={{ height: "100%" }}>
                                    <Col xs={9}>
                                        <Row className='customer-add-anagraph'>
                                            <Row>
                                                <p className='nac-title' style={{ fontSize: `${parseInt(globalContext.get.Theme.text_size) + 12}pt` }}>{textContext.get(['customers', 'form_customers'], ['title'], textContext.value)}</p>
                                            </Row>
                                            <Row className='my-3'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'form_customers'], ['customer_name'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='Mario'
                                                        value={addForm.cus_name}
                                                        onChange={e => setAddForm(draft => { draft.cus_name = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.cus_name = true })}
                                                        isValid={formChecks.good.cus_name}
                                                        isInvalid={formChecks.bad.cus_name}
                                                    />
                                                </InputGroup>
                                                <InputGroup className='mt-2' hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'form_customers'], ['customer_surname'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='Müller'
                                                        value={addForm.cus_surname}
                                                        onChange={e => setAddForm(draft => { draft.cus_surname = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.cus_surname = true })}
                                                        isValid={formChecks.good.cus_surname}
                                                        isInvalid={formChecks.bad.cus_surname}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-4'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'form_customers'], ['customer_phone'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='+41'
                                                        style={{ maxWidth: "calc(var(--text-font-size) * 4)" }}
                                                        value={addForm.phn_prefix}
                                                        onChange={e => setAddForm(draft => { draft.phn_prefix = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.phn_prefix = true })}
                                                        isValid={formChecks.good.phn_prefix}
                                                        isInvalid={formChecks.bad.phn_prefix}
                                                    />
                                                    <FormControl
                                                        type="text"
                                                        placeholder='76 579 43 67'
                                                        value={addForm.phn_number}
                                                        onChange={e => setAddForm(draft => { draft.phn_number = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.phn_number = true })}
                                                        isValid={formChecks.good.phn_number}
                                                        isInvalid={formChecks.bad.phn_number}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-2'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'form_customers'], ['customer_email'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='info@nacweb.ch'
                                                        value={addForm.cus_email}
                                                        onChange={e => setAddForm(draft => { draft.cus_email = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.cus_email = true })}
                                                        isValid={formChecks.good.cus_email}
                                                        isInvalid={formChecks.bad.cus_email}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            {showSameMail?
                                            <p> {textContext.get(['customers', 'form_customers'], ['rubata'], textContext.value)} </p>
                                            :<></>}
                                            <Row className='mt-2'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'info_customers'], ['festa'], textContext.value)} </InputGroup.Text>
                                                    <FormControl
                                                        type='date'
                                                        value={addForm.cus_birthday}
                                                        onChange={(e) => setAddForm(draft => { draft.cus_birthday = e.target.value })}
                                                        max={moment().format('YYYY-MM-DD')}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-2'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'form_customers'], ['customer_note'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        as="textarea"
                                                        rows={4}
                                                        maxLength={399}
                                                        placeholder={textContext.get(['customers', 'form_customers'], ['customer_note'], textContext.value)}
                                                        value={addForm.cus_notes}
                                                        onChange={e => setAddForm(draft => { draft.cus_notes = e.target.value })}
                                                    />
                                                </InputGroup>
                                            </Row>

                                        </Row>
                                        <Row className='customer-add-buttons'>
                                            <Col xs={3}>
                                                <button type="button" className='nac-button' onClick={resetAdd}>
                                                    <RiEraserLine className='customer-add-button' size={'4vh'} />
                                                </button>
                                            </Col>
                                            <Col xs={3}>
                                                <button type="button" className='nac-button' onClick={(e) => { e.preventDefault(); addCustomer() }}  >
                                                    <RiCheckLine className='customer-add-button' size={'4vh'} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={3} >
                                        <Row className='customer-add-switches'>
                                            <Row className=''>
                                                <p className='nac-text'>{textContext.get(['customers', 'form_customers'], ['customer_contact'], textContext.value)}</p>
                                            </Row>
                                            <Row className=' d-flex justify-content-center mt-2'>
                                                <GoodSwitch
                                                    label={textContext.get(['customers', 'form_customers'], ['is_sms'], textContext.value)}
                                                    reset={resetSwitches}
                                                    value={addForm.cus_enable_sms}
                                                    onChange={(e) => setAddForm(draft => { draft.cus_enable_sms = e })}
                                                />
                                            </Row>

                                            <Row className=' d-flex justify-content-center mt-2'>
                                                <GoodSwitch
                                                    label={textContext.get(['customers', 'form_customers'], ['is_email'], textContext.value)}
                                                    reset={resetSwitches}
                                                    value={addForm.cus_enable_email}
                                                    onChange={(e) => setAddForm(draft => { draft.cus_enable_email = e })}
                                                />
                                            </Row>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                    {showEdit && (
                        <Col xs={7} className='customers-add-container'>
                            <Form>
                                <Row style={{ height: "100%" }}>
                                    <Col xs={9}>
                                        <Row className='customer-add-anagraph'>
                                            <Row>
                                                <p className='nac-title' style={{ fontSize: `${parseInt(globalContext.get.Theme.text_size) + 12}pt` }}>{textContext.get(['customers', 'edit_customers'], ['title'], textContext.value)}</p>
                                            </Row>
                                            <Row className='my-3'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'edit_customers'], ['customer_name'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='Mario'
                                                        value={editForm.cus_name}
                                                        onChange={e => setEditForm(draft => { draft.cus_name = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.cus_name = true })}
                                                        isValid={formChecks.good.cus_name}
                                                        isInvalid={formChecks.bad.cus_name}
                                                    />
                                                </InputGroup>
                                                <InputGroup className='mt-2' hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'edit_customers'], ['customer_surname'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='Müller'
                                                        value={editForm.cus_surname}
                                                        onChange={e => setEditForm(draft => { draft.cus_surname = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.cus_surname = true })}
                                                        isValid={formChecks.good.cus_surname}
                                                        isInvalid={formChecks.bad.cus_surname}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-4'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'edit_customers'], ['customer_phone'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='+41'
                                                        style={{ maxWidth: "calc(var(--text-font-size) * 4)" }}
                                                        value={editForm.phn_prefix}
                                                        onChange={e => setEditForm(draft => { draft.phn_prefix = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.phn_prefix = true })}
                                                        isValid={formChecks.good.phn_prefix}
                                                        isInvalid={formChecks.bad.phn_prefix}
                                                    />
                                                    <FormControl
                                                        type="text"
                                                        placeholder='76 579 43 67'
                                                        value={editForm.phn_number}
                                                        onChange={e => setEditForm(draft => { draft.phn_number = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.phn_number = true })}
                                                        isValid={formChecks.good.phn_number}
                                                        isInvalid={formChecks.bad.phn_number}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-2'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'edit_customers'], ['customer_email'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        placeholder='info@nacweb.ch'
                                                        value={editForm.cus_email}
                                                        onChange={e => setEditForm(draft => { draft.cus_email = e.target.value })}
                                                        onFocus={(e) => setFormChecks(draft => { draft.touched.cus_email = true })}
                                                        isValid={formChecks.good.cus_email}
                                                        isInvalid={formChecks.bad.cus_email}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-2'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'info_customers'], ['festa'], textContext.value)} </InputGroup.Text>
                                                    <FormControl
                                                        type='date'
                                                        value={editForm.cus_birthday}
                                                        onChange={(e) => setEditForm(draft => { draft.cus_birthday = e.target.value })}
                                                        max={moment().format('YYYY-MM-DD')}
                                                    />
                                                </InputGroup>
                                            </Row>
                                            <Row className='mt-2'>
                                                <InputGroup hasValidation>
                                                    <InputGroup.Text>{textContext.get(['customers', 'edit_customers'], ['customer_note'], textContext.value)}</InputGroup.Text>
                                                    <FormControl
                                                        type="text"
                                                        as="textarea"
                                                        rows={4}
                                                        maxLength={399}
                                                        placeholder={textContext.get(['customers', 'edit_customers'], ['customer_note'], textContext.value)}
                                                        value={editForm.cus_notes}
                                                        onChange={e => setEditForm(draft => { draft.cus_notes = e.target.value })}
                                                    />
                                                </InputGroup>
                                            </Row>

                                        </Row>
                                        <Row className='customer-add-buttons'>
                                            <Col xs={3}>
                                                <button type="button" className='nac-button'>
                                                    <RiCloseLine className='customer-add-button' onClick={()=>{closeEdit(); setShowDetails(detailsRef.current)}} size={'4vh'} />
                                                </button>
                                            </Col>
                                            <Col xs={3}>
                                                <button type="button" className='nac-button'>
                                                    <RiCheckLine className='customer-add-button' onClick={editCustomer} size={'4vh'} />
                                                </button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={3} className='customer-add-switches'>
                                        <Row className=''>
                                            <p className='nac-text'>{textContext.get(['customers', 'edit_customers'], ['customer_contact'], textContext.value)}</p>
                                        </Row>
                                        <Row className=' d-flex justify-content-center mt-4'>
                                            <GoodSwitch
                                                label={textContext.get(['customers', 'edit_customers'], ['is_sms'], textContext.value)}
                                                reset={resetSwitches}
                                                value={editForm.cus_enable_sms}
                                                onChange={(e) => setEditForm(draft => { draft.cus_enable_sms = e })}
                                            />
                                        </Row>

                                        <Row className=' d-flex justify-content-center mt-2'>
                                            <GoodSwitch
                                                label={textContext.get(['customers', 'edit_customers'], ['is_email'], textContext.value)}
                                                reset={resetSwitches}
                                                value={editForm.cus_enable_email}
                                                onChange={(e) => setEditForm(draft => { draft.cus_enable_email = e })}
                                            />
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    )}
                    <Leftbar />
                </Row>
            </Container>

            <Modal show={showApt} onHide={() => { setShowApt(false); }} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{showApt && showApt.eve_title}</ModalTitle>
                </ModalHeader>
                <ModalBody className='' >
                    <Row className='my-4 mx-3 nac-text light-color' style={{ alignItems: 'center' }}>
                        <span className='color-circle' style={{ backgroundColor: showApt && showApt.Category.cat_color }} />
                        {showApt && showApt.Category.cat_name}
                    </Row>
                    {showApt && showApt.allDay ? (
                        <Row className='mt-4 mx-3 nac-text light-color'>
                            {textContext.get(['event', 'info_event'], ['total'], textContext.value)}
                        </Row>
                    ) : (
                        <>
                            <Row 
                                onClick={()=>{
                                    // calendarContext.get.changeDate(moment(showApt && showApt.eve_start, 'X').format('YYYY-MM-DDTHH:mm'));
                                    calendarContext.set(draft=>{draft.changeDate=moment(showApt && showApt.eve_start, 'X').format('YYYY-MM-DDTHH:mm')})
                                    navigate('/calendar');
                                    }} 
                                className='mt-4 mx-3 nac-text light-color'
                                style={{'cursor': 'pointer'}}
                            >
                                {textContext.get(['event', 'info_event'], ['date'], textContext.value)} {moment(showApt && showApt.eve_start, 'X').format("DD/MM/YYYY")}
                            </Row>
                            <Row className='mt-4 mx-3 nac-text light-color'>
                                {textContext.get(['event', 'info_event'], ['from'], textContext.value)} {moment(showApt && showApt.eve_start, 'X').format("HH:mm")}
                            </Row>
                            <Row className='mt-1 mx-3 nac-text light-color'>
                                {textContext.get(['event', 'info_event'], ['to'], textContext.value)} {moment(showApt && showApt.eve_end, 'X').format("HH:mm")}
                            </Row>
                        </>
                    )}
                    <Row className='my-4 mx-3 nac-text light-color'  >
                    {textContext.get(['event', 'info_event'], ['price'], textContext.value)} {showApt && showApt.Category.cat_price}<br />
                            {showApt && showApt.Appointment.apt_contact ? textContext.get(['event', 'info_event'], ['on_contact'], textContext.value) : textContext.get(['event', 'info_event'], ['off_contact'], textContext.value)}
                    </Row>
                    {showApt && showApt.rec_index ? (
                        <Row className='my-4 mx-3 nac-text light-color'>
                            {textContext.get(['event', 'info_event'], ['name_app'], textContext.value)}
                        </Row>
                    ) : (<></>)}
                    <Row className='my-4 mx-3 nac-text light-color'>
                        {textContext.get(['customers', 'info_customers'], ['nots'], textContext.value)} {showApt && showApt.eve_note}
                    </Row>
                </ModalBody>
            </Modal>
            <Modal show={showDelete} onHide={() => { setShowDelete(false) }} >
                <ModalHeader closeButton>
                    <ModalTitle className='nac-title'>{textContext.get(['customers', 'delete_customers'], ['title'], textContext.value)}</ModalTitle>
                </ModalHeader>

                <ModalBody className='' >
                    <Row className='mt-4 mx-3 nac-text light-color'>
                        {textContext.get(['customers', 'delete_customers'], ['description'], textContext.value)}
                    </Row>
                </ModalBody>
                <ModalFooter className='d-block'>
                    <Row>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color'>
                                <RiCloseLine onClick={() => { setShowDelete(false) }} size={'3vh'} />
                            </button>
                        </Col>
                        <Col xs={6}>
                        </Col>
                        <Col xs={3} className='d-flex justify-content-center'>
                            <button type="button" className='nac-button light-color' >
                                <RiCheckLine onClick={() => deleteCustomer(showDetails.ID)} size={'3vh'} />
                            </button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default Customers